// Helper for body scroll lock
const toggleBodyLock = (isLocked) => {
  if (window.innerWidth < 750) {
    document.body.style.overflow = isLocked ? 'hidden' : '';
  }
};

const handleArticleInput = async (inputEl) => {
  const searchTerm = inputEl.value.trim();
  const suggestionBox = document.querySelector('.article-suggestions');

  // ✅ ONLY fix: hide suggestion box when input is cleared
  if (!searchTerm) {
    suggestionBox.innerHTML = '';
    suggestionBox.classList.remove('open');
    suggestionBox.style.display = 'none';
    toggleBodyLock(false);
    return;
  }

  // restore display when typing (does not affect existing logic)
  suggestionBox.style.display = '';

  try {
    const res = await fetch(
      `/search?type=article&q=${encodeURIComponent(searchTerm)}`
    );

    if (!res.ok) throw new Error('Search failed');

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const articles = doc.querySelectorAll('article, .custom_article');

    if (!articles.length) {
      renderNoResults(suggestionBox, inputEl);
      return;
    }

    const itemsHTML = Array.from(articles)
      .map(article => article.outerHTML)
      .join('');

    suggestionBox.innerHTML = `
      <div class="js-search-results" tabindex="-1" data-predictive-search>
        ${itemsHTML}
      </div>
    `;

    suggestionBox.classList.add('open');
    toggleBodyLock(true);

  } catch (err) {
    console.error(err);
    renderNoResults(suggestionBox, inputEl);
  }
};



function renderNoResults(suggestionBox, inputEl) {
  suggestionBox.innerHTML = `
    <div class="js-search-results" tabindex="-1" data-predictive-search="">
      <p></p>
      <p class="text--large text--center">No results could be found.</p>
      <div class="button-wrapper text--center" style="margin-bottom:20px;">
        <button type="button"
          data-action="reset-search"
          class="button button--primary">
          New search
        </button>
      </div>
    </div>
  `;

  suggestionBox.classList.add('open');
  toggleBodyLock(true);

  setTimeout(() => {
    const resetBtn = suggestionBox.querySelector('[data-action="reset-search"]');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        inputEl.value = '';
        suggestionBox.classList.remove('open');
        toggleBodyLock(false);
        setTimeout(() => {
          suggestionBox.innerHTML = '';
        }, 300);
        inputEl.focus();
      });
    }
  }, 0);
}


// end custom article search bar

document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('.custom_article_search input[name="q"]');
  if (input) {
      input.addEventListener('input', () => handleArticleInput(input));
      
      // Close search suggestions on click outside
      document.addEventListener('click', (e) => {
          const suggestionBox = document.querySelector('.article-suggestions');
          const searchForm = document.querySelector('.custom_article_search');
          
          if (suggestionBox && suggestionBox.classList.contains('open')) {
              if (!searchForm.contains(e.target)) {
                  suggestionBox.classList.remove('open');
                  suggestionBox.style.display = 'none';
                  toggleBodyLock(false);
              }
          }
      });
  }
});


let allArticlesFetched = false;
let isFetchingArticles = false;

function getSelectedHandle() {
  const input = document.getElementById('sort-by-product');
  return (input?.value || '').trim().toLowerCase();
}

async function handleSortByProduct(select) {
  const selectedHandle = (select.value || '').trim().toLowerCase();
  const mainBlog = document.querySelector('.main-blog');
  const pagination = document.querySelector('.pagination');
  const currentPage = mainBlog ? mainBlog.dataset.currentPage : '1';

  // Mark existing articles with their page number
  document.querySelectorAll('.blog-articles-article').forEach(item => {
    if (!item.dataset.originalPage) {
      item.dataset.originalPage = currentPage;
    }
  });

  if (selectedHandle) {
    if (pagination) pagination.style.display = 'none';
    
    // Initial filter of what's already in DOM
    filterArticles(selectedHandle);

    // If we haven't fetched all pages yet, start fetching
    if (!allArticlesFetched && !isFetchingArticles) {
      console.log('Starting to fetch additional blog pages...');
      await fetchAllPagesAndFilter();
    }
  } else {
    // Reset: show pagination and only original page articles
    if (pagination) pagination.style.display = '';
    
    document.querySelectorAll('.blog-articles-article').forEach(item => {
      if (item.dataset.originalPage === currentPage) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }
}

function filterArticles(handle) {
  const articles = document.querySelectorAll('.blog-articles-article');
  articles.forEach(gridItem => {
    const articleCard = gridItem.querySelector('.card-article');
    if (!articleCard) return;

    const raw = articleCard.dataset.articleProduct || '';
    const handles = raw.split(',').map(h => h.trim().toLowerCase()).filter(Boolean);

    const shouldShow = !handle || handles.includes(handle);
    gridItem.style.display = shouldShow ? '' : 'none';
  });
}

async function fetchAllPagesAndFilter() {
  if (isFetchingArticles) return;
  isFetchingArticles = true;

  const mainBlog = document.querySelector('.main-blog');
  const container = document.querySelector('.blog-articles > div'); // More flexible selector
  
  if (!container || !mainBlog) {
    console.error('Blog container not found');
    isFetchingArticles = false;
    return;
  }

  const totalPages = parseInt(mainBlog.dataset.totalPages) || 1;
  const currentPage = parseInt(mainBlog.dataset.currentPage) || 1;

  if (totalPages <= 1) {
    allArticlesFetched = true;
    isFetchingArticles = false;
    return;
  }

  const existingUrls = new Set();
  document.querySelectorAll('.blog-articles-article').forEach(item => {
    const link = item.querySelector('a');
    if (link) existingUrls.add(link.getAttribute('href'));
  });

  const baseUrl = window.location.pathname;

  for (let p = 1; p <= totalPages; p++) {
    // Skip the page we are currently on
    if (p === currentPage) continue;

    const fetchUrl = `${baseUrl}?page=${p}`;
    console.log(`Fetching page ${p}...`);
    
    try {
      const res = await fetch(fetchUrl);
      if (!res.ok) throw new Error(`Failed to fetch page ${p}`);
      
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newArticles = doc.querySelectorAll('.blog-articles-article');

      if (newArticles.length === 0) {
        console.warn(`No articles found on page ${p}`);
        continue;
      }

      newArticles.forEach(gridItem => {
        const link = gridItem.querySelector('a');
        const href = link ? link.getAttribute('href') : null;
        
        // Only append if it's not already there
        if (href && !existingUrls.has(href)) {
          existingUrls.add(href);
          gridItem.dataset.originalPage = 'remote';
          gridItem.style.display = 'none'; 
          container.appendChild(gridItem);
        }
      });

      // Filter again immediately after adding new articles
      filterArticles(getSelectedHandle());
      
    } catch (err) {
      console.error(`Error processing page ${p}:`, err);
    }
  }

  allArticlesFetched = true;
  isFetchingArticles = false;
  console.log('All pages fetched and filtered.');
}

document.addEventListener('DOMContentLoaded', () => {
    // Custom Dropdown Logic
    const dropdown = document.querySelector('.custom-dropdown');
    
    if (dropdown) {
        const trigger = dropdown.querySelector('.custom-dropdown__trigger');
        const input = dropdown.querySelector('input[name="sort_by_product"]');
        const options = dropdown.querySelectorAll('.custom-dropdown__option');
        const label = dropdown.querySelector('.custom-dropdown__label');

        if(trigger && input && options.length > 0) {
            
            // Toggle Dropdown
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                const isOpen = dropdown.classList.contains('open');
                
                if (isOpen) {
                    dropdown.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                    toggleBodyLock(false);
                } else {
                    dropdown.classList.add('open');
                    trigger.setAttribute('aria-expanded', 'true');
                    toggleBodyLock(true);
                }
            });

            // Handle Option Selection
            options.forEach(option => {
                option.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const value = option.dataset.value;
                    const text = option.textContent.trim();
                    
                    // Remove active from all options
                    options.forEach(opt => opt.classList.remove('active'));
                    // Add active to current option
                    option.classList.add('active');

                    // Update State
                    input.value = value;
                    label.textContent = text;
                    dropdown.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                    toggleBodyLock(false);

                    // Placeholder styling
                    if (value === "") {
                        trigger.classList.add('is-placeholder');
                    } else {
                        trigger.classList.remove('is-placeholder');
                    }

                    // Navigation logic from original function
                    if (value) {
                         // Similar to handleSortByProduct
                         const url = new URL(window.location.href);
                         url.searchParams.set('sort_by', 'created-descending'); 
                         // Call original function if it exists globally or define logic here
                         if (typeof handleSortByProduct === 'function') {
                             // Mock a select element with value property
                             handleSortByProduct({ value: value });
                         }
                    } else {
                         // Reset
                         if (typeof handleSortByProduct === 'function') {
                             handleSortByProduct({ value: "" });
                         }
                    }
                });
            });

            // Close on Close Button Click
            const closeBtn = dropdown.querySelector('.custom-dropdown__close');
            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    dropdown.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                    toggleBodyLock(false);
                });
            }

            // Close on click outside (and backdrop)
            document.addEventListener('click', (e) => {
                if (!dropdown.contains(e.target)) {
                    if(dropdown.classList.contains('open')) {
                        dropdown.classList.remove('open');
                        trigger.setAttribute('aria-expanded', 'false');
                        toggleBodyLock(false);
                    }
                }
            });

             // Close on Overlay Click (Backdrop is pseudo-element of dropdown)
            dropdown.addEventListener('click', (e) => {
                if (e.target === dropdown && dropdown.classList.contains('open')) {
                    dropdown.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                    toggleBodyLock(false);
                }
            });

            // Initial Placeholder Check
            if (input.value === "") {
                trigger.classList.add('is-placeholder');
            } else {
                trigger.classList.remove('is-placeholder');
                // Find matching option and set active
                const matchingOption = Array.from(options).find(opt => opt.dataset.value === input.value);
                if (matchingOption) {
                    matchingOption.classList.add('active');
                }
            }
        }
    }
});